import React from "react";
import { UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
import PermissionMatrix from "./PermissionMatrix";

type CreatRoleModalProps = {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: UseFormSetValue<any>;
  defaultValues?: any;
  readOnly?: boolean;
  allowedModules?: readonly string[];
};

const CreatRoleModal = ({
  register,
  errors,
  setValue,
  defaultValues,
  readOnly,
  allowedModules,
}: CreatRoleModalProps) => {
  return (
    <div className="w-full overflow-y-auto h-[calc(100vh-16rem)] overflow-hidden space-y-4">
      <PermissionMatrix
        register={register}
        errors={errors}
        setValue={setValue}
        defaultPermissions={defaultValues?.permissions || []}
        readOnly={readOnly}
        allowedModules={allowedModules}
      />
    </div>
  );
};

export default CreatRoleModal;
